// Aviso global de la interna: si CUALQUIER consulta falló (listas, fichas, configuración), se dice arriba de la
// pantalla con el motivo y un botón para reintentar. Antes, una consulta rechazada dejaba la pantalla vacía en
// silencio (así se vio el 30-sep, con la sesión de un cliente dentro de la interna).
import { useQueryClient, type Query } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { ErrorDeCarga } from "./comun";

const conError = (q: Query) => q.state.status === "error" && q.getObserversCount() > 0;

export const ErroresDeConsulta = () => {
  const qc = useQueryClient();
  const [errores, setErrores] = useState<unknown[]>([]);
  useEffect(() => {
    const cache = qc.getQueryCache();
    let vivo = true;
    let pendiente = false;
    // Los eventos del caché llegan por montones (y a veces en pleno render de otro componente): se juntan en una
    // sola lectura por vuelta, y el estado solo cambia si cambió la lista de errores (si no, se re-pinta sin fin).
    const leer = () => {
      if (pendiente) return;
      pendiente = true;
      queueMicrotask(() => {
        pendiente = false;
        if (!vivo) return;
        const nuevos = cache.findAll({ predicate: conError }).map((q) => q.state.error);
        setErrores((antes) =>
          antes.length === nuevos.length && antes.every((e, i) => e === nuevos[i]) ? antes : nuevos,
        );
      });
    };
    leer();
    const soltar = cache.subscribe((evento) => {
      if (evento.type === "updated" || evento.type === "removed" || evento.type === "observerAdded" || evento.type === "observerRemoved")
        leer();
    });
    return () => {
      vivo = false;
      soltar();
    };
  }, [qc]);
  if (!errores.length) return null;
  return (
    <ErrorDeCarga
      error={errores[0]}
      que={errores.length > 1 ? `los datos (fallaron ${errores.length} consultas)` : "los datos"}
      onReintentar={() => qc.refetchQueries({ predicate: conError })}
    />
  );
};
